<template>
<div class="chapter">
<div class="inner_page">
<div class="epigraphPage" id="epi01">
<a id="page04"></a>
<a id="page05"></a>
<div class="epigraph">
<p class="epigraphText">Phantoms are fingerprints of the soul.</p>
<p class="epigraphSource"><em class="italic">—Anonymous, Babylon, 2500 <span class="smallCaps">B.C</span>.</em></p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?2ec7f50c